import loadable from '@loadable/component';

export const HomePage = loadable(() =>
  import('./HomePage').then(module => module.HomePage),
);
